// extracted by mini-css-extract-plugin
export default {"header":"contentComp_header__T9M8s","container":"contentComp_container__vitTX"};